// extracted by mini-css-extract-plugin
export var divider = "_34-0";
export var dividerText = "_34-1";